import { render, staticRenderFns } from "./taxpayers-verification-icon.vue?vue&type=template&id=73a16a06"
import script from "./taxpayers-verification-icon.vue?vue&type=script&lang=js"
export * from "./taxpayers-verification-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports